import React, { ElementType } from 'react';
import clsx from 'classnames';
import { SignInStatusType } from 'state/sign-in';
import { FingerBackground } from 'common/finger-background';
import { ForbiddenMessage } from 'pages/user/components';
import { useSignIn } from './use-sign-in';
import { EmailForm, EmailNotification } from './components';

import styles from './sign-in.module.scss';

const states: Record<SignInStatusType, ElementType> = {
  SIGN_IN: EmailForm,
  SIGN_IN_ERROR: EmailForm,
  SIGN_IN_FORBIDDEN: ForbiddenMessage,
  SUCCESS_EMAIL_SEND: EmailNotification,
};

export const SignInPage = () => {
  const { signInStatus, ...props } = useSignIn();
  const PanelByState = states[signInStatus];

  return (
    <div className={clsx(styles.container)}>
      <FingerBackground />
      <PanelByState {...props} />
    </div>
  );
};
